<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    padding?: string
    gap?: string
}

const props = withDefaults(defineProps<Props>(), {
    padding: '5',
    gap: '5',
})

const classes = computed(() => `flex flex-wrap gap-y-${props.gap} -mx-${props.padding}`)
</script>

<template>
    <div :class="classes">
        <slot />
    </div>
</template>
